module.exports = __webpack_public_path__ + "static/media/home_slide_next.f8fa05ce.svg";